import { css } from '@emotion/react';
import { Box, styled } from '@mui/joy';

export const TableScrollContainer = styled(Box)(
  () => css`
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: auto;

    &::before {
      left: 0;
    }

    &::after {
      right: 0;
    }
  `,
);
